import { render } from "./BottomListThemeProp.vue?vue&type=template&id=963c8d28&scoped=true"
import script from "./BottomListThemeProp.vue?vue&type=script&lang=js"
export * from "./BottomListThemeProp.vue?vue&type=script&lang=js"

import "./BottomListThemeProp.vue?vue&type=style&index=0&id=963c8d28&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963c8d28"]])

export default __exports__